import { getAgreementBaseInfoApi } from '@/api/workPlace/agreement'
import { computed, ref, watch } from 'vue'
import store from '@/store'

// 获取协定方基本信息
export default function useAgreementBaseInfo() {
  const workOrderGroupInfo = computed(() => store.state.workOrder.workOrderGroupInfo)
  const agreementBaseInfo = ref({})
  const getList = async () => {
    const groupInfo = workOrderGroupInfo?.value ?? {}
    const ucDoctorId = groupInfo?.doctorInfo?.ucUserId ?? ''
    if (!ucDoctorId) return
    try {
      const res = await getAgreementBaseInfoApi({ ucDoctorId })
      agreementBaseInfo.value = res
    } catch (error) {
      console.error('Error fetching agreement base info:', error)
    }
  }
  watch(
    () => workOrderGroupInfo.value,
    () => {
      getList()
    },
    { immediate: true }
  )
  return {
    agreementBaseInfo
  }
}
